import {
  ArchiveBoxIcon,
  CheckIcon,
  CircleStackIcon,
  CubeIcon,
  ShoppingCartIcon,
  XCircleIcon
} from '@heroicons/react/20/solid';
import { PencilIcon } from '@heroicons/react/24/solid';
import { useMemo } from 'react';

import { Stage } from 'src/shared/types/product';

import { Tag } from '../ui';

interface StageTagProps {
  type: Stage;
}

const StageTag: React.FC<StageTagProps> = ({ type }) => {
  const icon = useMemo(() => {
    switch (type) {
      case 'sampling':
        return (
          <div className="ml-1 size-4 min-h-4 min-w-4 flex items-center justify-center bg-cyan rounded-md p-[3px]">
            <CubeIcon className="size-3 text-cyan-light-3" />
          </div>
        );

      case 'quoting':
        return (
          <div className="ml-1 size-4 min-h-4 min-w-4 flex items-center justify-center bg-green rounded-md p-[3px]">
            <CircleStackIcon className="size-3 text-green-light-6" />
          </div>
        );

      case 'ordering':
        return (
          <div className="ml-1 size-4 min-h-4 min-w-4 flex items-center justify-center bg-grape-7 rounded-md p-[3px]">
            <ShoppingCartIcon className="size-3 text-grape-1" />
          </div>
        );

      case 'archived':
        return (
          <div className="ml-1 size-4 min-h-4 min-w-4 flex items-center justify-center bg-red-8 rounded-md p-[3px]">
            <ArchiveBoxIcon className="size-3 text-red-2" />
          </div>
        );

      case 'rejected':
        return (
          <div className="ml-1 size-4 min-h-4 min-w-4 flex items-center justify-center bg-red-8 rounded-md p-[3px]">
            <XCircleIcon className="size-3 text-red-2" />
          </div>
        );

      case 'draft':
        return (
          <div className="ml-1 size-4 min-h-4 min-w-4 flex items-center justify-center bg-secondary-text rounded-md p-[3px]">
            <PencilIcon className="size-3 text-gray-4" />
          </div>
        );

      case 'delivered':
        return (
          <div className="ml-1 size-4 min-h-4 min-w-4 flex items-center justify-center bg-green rounded-md p-[3px]">
            <CheckIcon className="size-3 text-green-light-6" />
          </div>
        );

      default:
        return null;
    }
  }, [type]);

  return (
    <Tag
      startContent={icon}
      className="capitalize bg-white border px-0 text-primary-text"
      color="default"
      classNames={{ content: 'pl-1 pr-2' }}
    >
      {type}
    </Tag>
  );
};

export default StageTag;
